import { Outlet } from '@tanstack/react-router'

import { BreadcrumbTrail, PageHeader, Skeleton } from '@/components/ui'
import { useDocument, useFetchDocument } from '@/modules/documents'
import { getFolderPath } from '@/utils'
import HeaderActions from './HeaderActions'

interface DocumentLayoutProps {
  id: string
}

export const DocumentLayout = ({ id }: DocumentLayoutProps) => {
  useFetchDocument(id)
  const document = useDocument()

  const folderCrumb = document
    ? document.folder && {
        label: document.folder.name,
        to: getFolderPath(document.folder),
      }
    : { label: <Skeleton className="h-4 w-24" /> }

  return (
    <div className="flex flex-col gap-8 h-full">
      <div className="flex flex-col gap-6">
        <BreadcrumbTrail
          crumbs={[{ label: 'Documents', to: '/documents' }, folderCrumb]}
          page={document?.fileName || <Skeleton className="h-5 w-44" />}
        />

        <PageHeader
          title={document?.fileName || <Skeleton className="block h-9 w-96" />}
          subtitle={
            document ? (
              document.folder?.name
            ) : (
              <Skeleton className="block h-7 w-40" />
            )
          }
        >
          {document ? (
            <HeaderActions document={document} />
          ) : (
            <Skeleton className="h-8 w-24 rounded-md" />
          )}
        </PageHeader>
      </div>

      <div className="flex flex-1 min-h-0">
        <Outlet />
      </div>
    </div>
  )
}
